export const SearchFormActionsComponent = {
  templateUrl:
    './app/ajs/_shared/components/search-form-actions/search-form-actions.component.html',
  bindings: {
    searched: '&',
    searchCleared: '&',
    disabled: '<', // =
  },
  controller: SearchFormActionsController,
  controllerAs: 'vm',
};

function SearchFormActionsController() {
  const vm = this;

  // public methods
  // -----------------------
  vm.clearSearch = function () {
    vm.searchCleared();
  };

  vm.search = function () {
    if (vm.disabled) return;

    vm.searched();
    // { $isFormValid: isFormValid, $formValid: formValid }
  };
}
